export const topMakesAvto = [
  8,
  11,
  19,
  20,
  22,
  25,
  35,
  37,
  41,
  49,
  52,
  62,
  68,
  75,
  179,
  81,
  83,
  85,
  87,
  93,
  101,
  106,
  107,
  113,
  118,
  3259,
  125,
  126,
  130,
  // commercial
  4341,
  4329,
  4338,
  4328,
  4335,
  4337,
  4367,
  4333,
  4331,
  4330,
  // bus
  4207,
  4219,
  4247,
  4220,
  4217,
  4224,
  4236,
  4245,
  // pritsepy
  5064,
  4940,
  4928,
  4930,
  4933,
  4935,
  4944,
  4923,
  4962,
  5217,
  // spetstekhyka
  4475,
  4439,
  4493,
  4469,
  4453,
  4482,
  11361,
  4441,
  4449,
  4437,
  // moto
  3337,
  3386,
  3341,
  3365,
  3355,
  3347,
  3383,
  3343,
  3351,
  3352,
];



// WEBPACK FOOTER //
// ./src/shared/constants/topMakes.js